module.exports = __webpack_public_path__ + "img/reader-1-350x321.af8f4504.png";